interface LogoProps {
  /** Altura em px. A largura acompanha a proporcao original do arquivo. */
  height?: number;
  className?: string;
}

/**
 * Marca ClearTask. O arquivo e o PNG original fornecido; a marca d'agua de
 * fundo dele e clara o bastante para nao brigar com a superficie.
 */
export function Logo({ height = 28, className }: LogoProps) {
  return (
    <img
      src="/brand/cleartask-logo.png"
      alt="ClearTask"
      height={height}
      style={{ height, width: 'auto' }}
      className={className}
    />
  );
}
